import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyATlyXb2pp9x5dCCukJfUWeOUHhJ5oL_aE",
  authDomain: "spartan-eats-808bd.firebaseapp.com",
  databaseURL: "https://spartan-eats-808bd.firebaseio.com",
  projectId: "spartan-eats-808bd",
  storageBucket: "spartan-eats-808bd.appspot.com",
  messagingSenderId: "1096879646331",
  appId: "1:1096879646331:web:f23e362f9c06bdc63aa4de",
  measurementId: "G-YDXHNEWP6F"
};
firebase.initializeApp(firebaseConfig)

// utils
const fs = firebase.firestore
const fb_db = firebase.firestore()
const fb_auth = firebase.auth()
const fb_storage = firebase.storage().ref()

// collection references
const fb_users = fb_db.collection('users')
const fb_meals = fb_db.collection('meals')
const fb_survey = fb_db.collection('survey')

// export utils/refs
export {
  fs,
  fb_db,
  fb_auth,
  fb_storage,
  fb_users,
  fb_meals,
  fb_survey
}
